import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-790a5086"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("title", null, "MiROS | SignUp", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Forgot your password?", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, " Enter your email below, and we'll send you a link to reset your password with. ", -1))
const _hoisted_4 = {
  key: 0,
  class: "error-box center"
}
const _hoisted_5 = {
  key: 1,
  class: "error-box sent-box center"
}
const _hoisted_6 = { class: "center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "body-text" }, "Email:", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_9 = { class: "sub-div" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "body-text subtitle" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Already have an account? Click here to sign in: ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("html", null, [
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("body", null, [
      (_ctx.errMsg != '')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.errMsg), 1))
        : _createCommentVNode("", true),
      (_ctx.sentMsg != '')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.sentMsg), 1))
        : _createCommentVNode("", true),
      _createElementVNode("table", _hoisted_6, [
        _createElementVNode("tr", null, [
          _hoisted_7,
          _createElementVNode("td", null, [
            _withDirectives(_createElementVNode("input", {
              onInput: _cache[0] || (_cache[0] = 
                () => {
                  _ctx.errMsg = '';
                  _ctx.sentMsg = '';
                }
              ),
              class: "input-box",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event))
            }, null, 544), [
              [_vModelText, _ctx.email]
            ])
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_8,
          _createElementVNode("td", null, [
            _createElementVNode("button", {
              class: "rectangle-button float-right",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.sendResetEmail && _ctx.sendResetEmail(...args)))
            }, " Send Email ")
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createVNode(_component_router_link, {
          class: "subtitle",
          to: "/login"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Sign In")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}